import * as types from './mutation-types'

export default {
  [types.UPDATE_HOME] (state, result) {
    Object.assign(state, result)
  }
}



// WEBPACK FOOTER //
// ./src/store/home/mutations.js